/**
 * Bio component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"

const Bio = () => {

  return (
    <div className="bio">
      <div>
        <p>
          <em>Initiative für ein lebenswertes, sauberes, schönes, grünes Straßgang.</em>
        </p>
      </div>
      <div>
        <ul>
          <li>Wir wollen nicht länger nur Durchzugsverkehrsbezirk sein.</li>
          <li>Wir wollen unser Bezirkszentrum wiederbeleben: Weniger Verkehr, dafür mehr Platz zum Flanieren und Verweilen.</li>
          <li>Wir wollen ein attraktives Kultur- und Freizeitangebot für alle</li>
          <li>Wir wollen Straßen und Radwege, auf denen sich auch Kinder sicher bewegen können</li>
        </ul>
      </div>
    </div>
  )
}

export default Bio
